import {mapGetters, mapMutations, mapActions} from 'vuex';
const _ = require('lodash');

export default {
    data(){
      return{
          category:null,
          product:null,
          choiceProduct: null,
          count:1,
          price:0,
          price_air:0,
          productList:null,
          categoryList:null,
          orderPayload: null,
      }
    },
    computed:{
      ...mapGetters({
          products:'catalog/products',
          order:'orders/order',
          productCategories:'catalog/productCategories',
          isUpsell:'orders/isUpsell'
      })
    },
    watch:{
        products(e) {
            this.productList = _.clone(e.data)
        },
        productCategories(e){
            this.categoryList = _.clone(e.data);
            this.categoryList.map(item=>{
                if(item.children.length){
                    item.children.map(childMap=>{
                        this.categoryList.push(childMap);
                    })
                }
            })
        }
    },
    created() {
        this.orderPayload = _.clone(this.order);
        this.getFilterProducts({});
        this.getProductCategories();
    },
    methods:{
        addProductToOrder(){
            if(this.count <= this.choiceProduct.max_quantity){
                const addedProduct = {
                    "id": null,
                    "uid": 'tmp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    "product_id": this.product,
                    "price": this.price,
                    "quantity": this.count,
                    "price_air": this.price_air,
                    "is_upsell": this.isUpsell,
                    product:{
                        "isbn": this.choiceProduct.isbn,
                        "title": this.choiceProduct.title,
                    }
                }
                this.$emit('addProduct', addedProduct);
                this.toggleShowAddProductPopUp(false)
            }else{
                this.$toasted.error(this.$t('popupAddProduct.err_not_enough'),{
                    duration : 3000,
                    position: 'top-center',
                });
            }
        },
        getCategoryForProducts(){
            this.productList = [];
            if(this.category === 99999999){
                this.products.data.map(item =>{
                    this.productList.push(item)
                })
            }else{
                this.products.data.map(item =>{
                    if(item.category_id === this.category){
                        this.productList.push(item)
                    }
                })
            }
        },
        getProduct(){
            this.choiceProduct = this.products.data.filter(item=>item.id === this.product)[0]
            if(this.choiceProduct){
                this.price = Number(this.choiceProduct.sale_price).toFixed(2)
            }
        },
        ...mapMutations({
            toggleShowAddProductPopUp: 'config/toggleShowAddProductPopUp',
        }),
        ...mapActions({
            getFilterProducts: 'catalog/getFilterProducts',
            getProductCategories: 'catalog/getProductCategories',
            editOrder:'orders/editOrder',
            showOrder:'orders/showOrder',
        })
    }
}
